// Generated by CoffeeScript 2.7.0
var Admin__SettingsController;

import GenerateMorePopover from './nav.js';

import SettingsNavigator from 'trunks/vue/admin/compositions/settings_sidebar/settings_navigator.js';

import welcomeActions from './welcome.js';

export default Admin__SettingsController = (function() {
  class Admin__SettingsController extends Skylark.App.BaseController {};

  Admin__SettingsController.include(GenerateMorePopover);

  Admin__SettingsController.include(SettingsNavigator);

  Admin__SettingsController.include(welcomeActions);

  return Admin__SettingsController;

}).call(this);
